import { createContext, useContext, useState } from "react";
import BookingDialog from "@/components/BookingDialog";

const Ctx = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(Ctx);

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, interest: "" });
  return (
    <Ctx.Provider value={{ openBooking: (interest = "") => setState({ open: true, interest }) }}>
      {children}
      <BookingDialog open={state.open} interest={state.interest} onClose={() => setState((s) => ({ ...s, open: false }))} />
    </Ctx.Provider>
  );
};
